import LegalLayout from "./LegalLayout";

export default function DatenschutzPage() {
  return (
    <LegalLayout title="Datenschutzerklärung" kicker="Privatsphäre">
      <p>
        Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten
        vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften (DSGVO) sowie dieser Datenschutzerklärung.
      </p>

      <h2>1. Verantwortlicher</h2>
      <p>
        Verantwortlich für die Datenverarbeitung ist:<br />
        <strong>Eljhat Kadrii e.U.</strong> (Haus des Handys)<br />
        Hernalser Hauptstraße 135, 1170 Wien<br />
        Firmenbuchnummer: FN 628945w · UID: ATU81376119<br />
        E-Mail: <a href="mailto:store@hausdeshandys.at">store@hausdeshandys.at</a><br />
        Telefon: <a href="tel:+436764440304">+43 676 4440304</a>
      </p>

      <h3>Hosting-Provider</h3>
      <p>
        Diese Website wird in einem EU-konformen Rechenzentrum gehostet. Auf Anfrage übermitteln wir
        gerne den Namen und die Adresse des aktuellen Hosting-Providers per E-Mail an
        <a href="mailto:store@hausdeshandys.at"> store@hausdeshandys.at</a>.
      </p>

      <h2>2. Erhebung & Verarbeitung personenbezogener Daten</h2>
      <p>Wir erheben personenbezogene Daten, wenn Sie:</p>
      <ul>
        <li>Eine Reparatur-Anfrage stellen (Name, Telefonnummer, optional E-Mail, Gerätetyp & Problem)</li>
        <li>Eine Bestellung im Online-Shop aufgeben (Name, Adresse, E-Mail, Telefon, Zahlungsdaten)</li>
        <li>Per WhatsApp oder Telefon Kontakt aufnehmen</li>
        <li>Unsere Website besuchen (technische Daten siehe Punkt 4)</li>
      </ul>

      <h2>3. Zwecke der Verarbeitung</h2>
      <ul>
        <li>Abwicklung Ihrer Reparatur- oder Bestellaufträge (Art. 6 Abs. 1 lit. b DSGVO)</li>
        <li>Kommunikation mit Ihnen (z. B. Statusupdates per WhatsApp/E-Mail)</li>
        <li>Rechnungslegung und buchhalterische Pflichten (Art. 6 Abs. 1 lit. c DSGVO)</li>
        <li>Verbesserung unseres Angebots (anonyme Statistiken)</li>
      </ul>

      <h2>4. Server-Logfiles</h2>
      <p>
        Beim Besuch unserer Website werden automatisch IP-Adresse, Browser-Typ, Referrer und Zeitstempel
        gespeichert. Diese Daten werden nach 30 Tagen anonymisiert.
      </p>

      <h2>5. Cookies</h2>
      <p>
        Wir verwenden technisch notwendige Cookies (z. B. für den Warenkorb). Marketing- oder Tracking-Cookies
        setzen wir nur mit Ihrer ausdrücklichen Einwilligung ein.
      </p>

      <h2>6. Zahlungsdienstleister</h2>
      <p>
        Für die Zahlungsabwicklung nutzen wir <strong>Stripe Payments Europe Ltd.</strong> (Irland). Bei einer
        Zahlung werden Ihre Daten (Name, Adresse, Zahlungsmittel) an Stripe übermittelt. Mehr dazu:&nbsp;
        <a href="https://stripe.com/at/privacy" target="_blank" rel="noreferrer">stripe.com/at/privacy</a>.
      </p>

      <h2>7. Ihre Rechte</h2>
      <p>Sie haben das Recht auf:</p>
      <ul>
        <li>Auskunft (Art. 15 DSGVO)</li>
        <li>Berichtigung (Art. 16 DSGVO)</li>
        <li>Löschung (Art. 17 DSGVO)</li>
        <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
        <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
        <li>Widerspruch (Art. 21 DSGVO)</li>
      </ul>
      <p>
        Beschwerden können Sie an die österreichische Datenschutzbehörde richten:&nbsp;
        <a href="https://www.dsb.gv.at" target="_blank" rel="noreferrer">www.dsb.gv.at</a>.
      </p>

      <h2>8. Speicherdauer</h2>
      <p>
        Personenbezogene Daten werden nur so lange gespeichert, wie es für die jeweiligen Zwecke erforderlich
        ist. Buchhalterische Daten werden gemäß § 132 BAO 7 Jahre aufbewahrt.
      </p>

      <p className="text-xs text-zinc-600 mt-12">
        Stand: Februar 2026. Eljhat Kadrii e.U. · FN 628945w · UID ATU81376119
      </p>
    </LegalLayout>
  );
}
